import { FeatureTour } from './feature-tour';

export class FeatureTourLocation {
	public id: number;
	public featureTourId: number;
	public name: string;
	public route: string;

	public featureTour?: FeatureTour;

	constructor(featureTourLocation?: FeatureTourLocation) {
		Object.assign(this, featureTourLocation);
	}
}
